// Abu Dhabi - coil chemical wash. Focus: humidity and mould on the islands.
const content = {
    slug: 'ac-coil-chemical-wash',
    title: (c) => `AC Coil Cleaning Abu Dhabi from ${c.money(c.tables.chemicalWash[0].wall)} | Mould & Smell`,
    description: (c) =>
        `AC coil chemical wash in Abu Dhabi from ${c.money(c.tables.chemicalWash[0].wall)}. Clears mould, musty smells and weak airflow from split and ducted units.`,
    eyebrow: 'Abu Dhabi · Coil cleaning',
    h1: 'AC Coil Cleaning in Abu Dhabi',
    lead: (c) =>
        `A musty smell the moment the AC starts is the most common complaint we hear from island apartments. It comes from mould on the coil and blower, and a chemical wash removes it - ${c.money(c.tables.chemicalWash[0].wall)} for one split unit.`,
    image: 'blog/living/dirty-aircon.jpg',
    imageAlt: 'Mould and dust inside an AC unit before coil cleaning',
    facts: ['Removes mould and smell', 'Split and ducted', 'About 90 minutes per unit'],
    priceTitle: 'Coil wash prices',
    priceIntro: (c) => `Split units from ${c.money(c.tables.chemicalWash[0].wall)}, ducted from ${c.money(c.tables.chemicalWash[0].ducted)}.`,
    panel: { type: 'servicing', services: ['chemicalWash'], defaultMount: 'Wall' },
    sections: [
        {
            title: 'Where the smell comes from',
            paragraphs: [
                'An AC removes moisture from the air, so its coil and drain tray are wet whenever it runs. In Abu Dhabi\'s coastal humidity - especially on Al Reem, Saadiyat and Yas, and in Corniche towers - they rarely dry out. Dust settles on the wet surfaces and mould grows on the dust.',
                'When the unit switches on, the blower pushes air through that layer and the smell comes with it. Washing the filter does not help, because the mould is on the coil fins and the curved blades of the blower wheel.',
            ],
        },
        {
            // Target of the hero card's Service Details link
            id: 'included',
            title: 'What the wash removes',
            tone: 'muted',
            items: [
                'Mould and biofilm on the coil fins.',
                'Black build-up on the blower wheel blades.',
                'Slime in the drain tray that blocks the condensate line.',
                'Dust baked onto the coil that cuts airflow.',
            ],
        },
        {
            title: 'Keeping it fresh afterwards',
            paragraphs: [
                'After the wash, run the unit on fan-only for ten minutes before switching it off at night, so the coil dries. Keep the filter clean monthly. In humid island homes, plan a coil wash every six months rather than once a year.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is AC coil cleaning in Abu Dhabi?',
            answer: (c) => `${c.money(c.tables.chemicalWash[0].wall)} for one split unit, ${c.money(c.tables.chemicalWash[1].wall)} for two, and ${c.money(c.tables.chemicalWash[0].ducted)} for one ducted unit.`,
        },
        {
            question: 'Will the smell come back?',
            answer: 'It can, if the coil stays wet and dusty. Drying the coil on fan mode and keeping filters clean slows it down a lot.',
        },
        {
            question: 'Is a coil wash safe if someone at home has asthma?',
            answer: 'Yes - it is often recommended, because it removes mould that the AC would otherwise blow around. Keep the room aired for a short while after the wash.',
        },
    ],
    schema: {
        name: 'AC Coil Cleaning in Abu Dhabi',
        serviceType: 'Air conditioner coil chemical cleaning',
        offers: (c) => [
            { name: 'Coil chemical wash, 1 split unit', price: c.tables.chemicalWash[0].wall },
            { name: 'Coil chemical wash, 2 split units', price: c.tables.chemicalWash[1].wall },
            { name: 'Coil chemical wash, 1 ducted unit', price: c.tables.chemicalWash[0].ducted },
        ],
    },
}

export default content
